import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { retrievePasswordQuery } from "@query";
import { useStores } from "@hooks";
import { Alert, ClearButton } from "@components";
import { ArrowLeft } from "@assets";
import { login, resetPassword } from "@paths";
import { PasswordRetrieveForm } from "@forms";

export const PasswordRetrieve = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { stateStore } = useStores();

  const [alertText, setAlertText] = useState("");

  const retrievePassword = async (data) => {
    try {
      const status = await retrievePasswordQuery(data);
      stateStore.setResetEmail(data.email);
      if (status) navigate(resetPassword, { replace: true });
    } catch (e) {
      if (e.response) setAlertText(e.response.data.error);
      else setAlertText(t("errors.network"));
    }
  };

  return (
    <>
      <p
        className="mb-8 text-md text-center uppercase"
        style={{ letterSpacing: 0.53 }}
      >
        {t("views.retrieve_password.forgotten")}
      </p>
      <p
        className="mb-8 text-md text-center"
        style={{ maxWidth: 290 }}
      >
        {t("views.retrieve_password.desc")}
      </p>

      <PasswordRetrieveForm onSubmit={retrievePassword} />

      <ClearButton
        fullWidth
        size="medium"
        className="mt-2"
        icon={<ArrowLeft />}
        to={login}
      >
        {t("views.retrieve_password.back")}
      </ClearButton>
      <Alert
        isOpen={Boolean(alertText)}
        title={alertText}
        acceptText={t("common.close")}
        onAccept={() => setAlertText("")}
      />
    </>
  );
};
